// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LayerInputProperties } from "./LayerInputProperties";
import {
  LayerInputPropertiesFromJSON,
  LayerInputPropertiesFromJSONTyped,
  LayerInputPropertiesToJSON,
  LayerInputPropertiesToJSONTyped,
} from "./LayerInputProperties";

/**
 *
 * @export
 * @interface LayerInput
 */
export interface LayerInput {
  /**
   *
   */
  type?: LayerInputTypeEnum;
  /**
   *
   */
  name: string;
  /**
   * Layer ID as defined in the file descriptor, or None for data types with only a single layer. NB: layer IDs are verified at creation time. If a file is later reprocessed, its descriptor layer IDs may change. Existing versions retain their original values and will still load, but API clients may encounter stale layer references.
   */
  layerInFile?: string | null;
  /**
   *
   */
  filePath: string;
  /**
   *
   */
  visible?: boolean;
  /**
   *
   */
  opacity?: number;
  /**
   *
   */
  properties?: LayerInputProperties | null;
}

/**
 * @export
 */
export const LayerInputTypeEnum = {
  Layer: "layer",
} as const;
export type LayerInputTypeEnum = (typeof LayerInputTypeEnum)[keyof typeof LayerInputTypeEnum];

/**
 * Check if a given object implements the LayerInput interface.
 */
export function instanceOfLayerInput(value: object): value is LayerInput {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    (!("filePath" in (value as Record<string, any>)) &&
      !("file_path" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["filePath"] === undefined &&
      (value as Record<string, any>)["file_path"] === undefined)
  )
    return false;
  return true;
}

export function LayerInputFromJSON(json: any): LayerInput {
  return LayerInputFromJSONTyped(json, false);
}

export function LayerInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayerInput {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    name: json["name"],
    layerInFile:
      json["layer_in_file"] === undefined
        ? undefined
        : json["layer_in_file"] === null
        ? null
        : json["layer_in_file"],
    filePath: json["file_path"],
    visible: json["visible"] == null ? undefined : json["visible"],
    opacity: json["opacity"] == null ? undefined : json["opacity"],
    properties:
      json["properties"] === undefined
        ? undefined
        : json["properties"] === null
        ? null
        : LayerInputPropertiesFromJSON(json["properties"]),
  };
}

export function LayerInputToJSON(json: any): LayerInput {
  return LayerInputToJSONTyped(json, false);
}

export function LayerInputToJSONTyped(
  value?: LayerInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    name: value["name"],
    layer_in_file: value["layerInFile"],
    file_path: value["filePath"],
    visible: value["visible"],
    opacity: value["opacity"],
    properties: LayerInputPropertiesToJSON(value["properties"]),
  };
}
